import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ErrorConfig {
  message: string;
  action?: string;
  duration?: number;
  type?: 'error' | 'warning' | 'info' | 'success';
}

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private snackBar = inject(MatSnackBar);

  /**
   * Show error message
   */
  showError(message: string, action: string = 'Close', duration: number = 5000): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(message, action, {
      duration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['error-snackbar']
    });
  }

  /**
   * Show success message
   */
  showSuccess(message: string, action: string = 'Close', duration: number = 3000): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(message, action, {
      duration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['success-snackbar']
    });
  }

  /**
   * Show warning message
   */
  showWarning(message: string, action: string = 'Close', duration: number = 4000): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(message, action, {
      duration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['warning-snackbar']
    });
  }

  /**
   * Show info message
   */
  showInfo(message: string, action: string = 'Close', duration: number = 3000): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(message, action, {
      duration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['info-snackbar']
    });
  }

  /**
   * Show custom error with config
   */
  show(config: ErrorConfig): MatSnackBarRef<SimpleSnackBar> {
    const panelClass = `${config.type || 'error'}-snackbar`;
    return this.snackBar.open(
      config.message,
      config.action || 'Close',
      {
        duration: config.duration || (config.type === 'error' ? 5000 : 3000),
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: [panelClass]
      }
    );
  }
}

